import setConstants from './loadAppConstants';
import setFeatureFlags from './loadFeatureFlags';
import setMessageSettings from './loadMessageSettings';
import setOnlineState from './setOnlineState';
import alertBanner from './alertBanner';

const actions = {
  setConstants,
  setFeatureFlags,
  setMessageSettings,
  setOnlineState,
  alertBanner,
};
export default actions;
